/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  RevertImportMutationRequest,
  RevertImportMutationResponse,
} from "../types/RevertImport.ts"

export const revertImportMutationKey = () =>
  [{ url: "/v1/product/revert-import" }] as const

export type RevertImportMutationKey = ReturnType<typeof revertImportMutationKey>

/**
 * @summary Revert import
 * {@link /v1/product/revert-import}
 */
export async function revertImport(
  data: RevertImportMutationRequest,
  config: Partial<RequestConfig<RevertImportMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    RevertImportMutationResponse,
    ResponseErrorConfig<Error>,
    RevertImportMutationRequest
  >({
    method: "POST",
    url: `/v1/product/revert-import`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function revertImportMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<RevertImportMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = revertImportMutationKey()
  return mutationOptions<
    ResponseConfig<RevertImportMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: RevertImportMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return revertImport(data, config)
    },
  })
}

/**
 * @summary Revert import
 * {@link /v1/product/revert-import}
 */
export function useRevertImport<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<RevertImportMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: RevertImportMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<RevertImportMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? revertImportMutationKey()

  const baseOptions = revertImportMutationOptions(config) as UseMutationOptions<
    ResponseConfig<RevertImportMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: RevertImportMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<RevertImportMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: RevertImportMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<RevertImportMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: RevertImportMutationRequest },
    TContext
  >
}
